import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { API, Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import './Level2.scss';
import StorePage from '../Store/Store'
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import Coin from '../Coin/Coin'
import Celebrate from '../Celebrate/Celebrate';
import Game from '../PressYourLuck/Game'
import Animal from '../Animal/Animal'
import Store from '../Store/store.jpg'
import Intro from '../Conversation/Intro';
import Build from '../Conversation/Build'
import Conversation from '../Conversation/Conversation'
import Valuation from '../Conversation/Valuation'
import Share from '../Conversation/Share'
import Surprise from '../SurpriseVideo/surprise';
import Draggable from 'react-draggable';
import presentSound from "./../../Unit1/Module1/assets/ta_da_gift.mp3"

const Level2 = (props) => {
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const { freeplay } = useSelector((state) => state.freeplay, shallowEqual);
    const firstUpdate = useRef(true);
    const dispatch = useDispatch();
    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;


    const [clientHeight, setVh] = useState(window.innerHeight);
    const [clientWidth, setVw] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setVh(window.innerHeight);
        setVw(window.innerWidth);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [clientHeight, clientWidth]);

    function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    const navigate = useNavigate();
    const [displayDecorate, setDisplayDecorate] = useState(props.decorate || props.store);
    const [displayStep0, setDisplayStep0] = useState(!props.decorate && !props.store);
    const [displayStep1, setDisplayStep1] = useState(false);
    const [displayStep2, setDisplayStep2] = useState(false);
    const [displayStep3, setDisplayStep3] = useState(false);
    const [displayStep4, setDisplayStep4] = useState(false);
    const [displayStore, setDisplayStore] = useState(props.store);
    const [displayStoreCharacter, setDisplayStoreCharacter] = useState(false);
    const [storeReady, setStoreReady] = useState(false);

    const [selectedStudentCharacter, setSelectedStudentCharacter] = useState(null)
    const [selectedFriendCharacter, setSelectedFriendCharacter] = useState(null)
    const [selectedConversation, setSelectedConversation] = useState(null)
    const [completePrompt, setCompletePrompt] = useState('')
    const [celebrateText, setCelebrateText] = useState('');
    const [celebrateVoice, setCelebrateVoice] = useState('');
    const [displaySurpriseVideoIcon, setDisplaySurpriseVideoIcon] = useState(false);
    const [displaySurpriseVideo, setDisplaySurpriseVideo] = useState(false);
    const [surpriseVideo, setSurpriseVideo] = useState("");
    const [prize, setPrize] = useState(false);
    const [disPlayPrize, setDisplayPrize] = useState(false);

    const [displayCoin, setDisplayCoin] = useState(false);
    const [displayValuation, setDisplayValuation] = useState(false);
    const [displayCelebrate, setDisplayCelebrate] = useState(false);
    const [displayCoinAfterConversation, setDisplayCoinAfterConversation] = useState(false);
    const [displayCoinAfterValuation, setDisplayCoinAfterValuation] = useState(false);
    const [displayCoinAfterCelebrate, setDisplayCoinAfterCelebrate] = useState(false);
    const [displayGame, setDisplayGame] = useState(false);
    const [displayShare, setDisplayShare] = useState(false);
    const [displayAnimal, setDisplayAnimal] = useState(false);
    const [animal, setAnimal] = useState('');
    const [animals, setAnimals] = useState([]);
    const [topicName, setTopicName] = useState('');
    const [name, setName] = useState('');
    const [change, setChange] = useState(false);
    const [practice, setPractice] = useState(false);
    const [topics, setTopics] = useState(null);
    const [conversationNum, setConversationNum] = useState(-1);
    const [conversationName, setConversationName] = useState('');
    const influencers = [login.influencerid, login.influencerid1,login.influencerid2,login.influencerid3,login.influencerid4,login.influencerid, login.influencerid1,login.influencerid2,login.influencerid3,login.influencerid4]
    const giftBtn = generateImageUrl('images/Images/Gift.png', login);
    const playIcon = generateImageUrl('images/newDesign/FreePlay/play.png')
    const rewardSound = new Audio(presentSound);
    const conversationNames = ['favorite', 'feeling', 'listening', 'friends', 'solution', 'conflict', 'advocacy', 'community']

    const updateFreeplay = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				name: "level2",
				coin: freeplay.level2Coin,
				progress: JSON.stringify(freeplay.level2),
                decorate: JSON.stringify(freeplay.level2Decorate)
			},
		}
		await API.put('TIR', '/v3/student/freeplay', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
        const myInit2 = {
            body: {
              id: login.studentid,
              current_module: 'Level2',
            },
          };
          await API.put('TIR', '/v3/student', myInit2)
          .then((response) => {
          })
          .catch((error) => {
          });
	})

    const getNestedLength = (obj) => {
        let length = 0;
        Object.values(obj).forEach(value => {
            Object.values(value).forEach(module => {
                if (module.unlocked === 1) {
                    length += 1
                }
            });
        });
        return length;
    };
    
    const updateProgress = (async () => {
        const totalLength = getNestedLength(freeplay.level2);
		const payload = {
			body: {
				id: login.studentid,
				module: `Level2`,
				day_completed: totalLength,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

    const getAnimalData = async (levelName, unlockedCount, animalName) => {
        if (Object.values(freeplay.level2[levelName]).filter(value => value.unlocked === 1).length === unlockedCount) {
            let photo;
            await GetUserVideo(`userfiles/${login.studentid}/level2_${levelName}_animal.png`).then((data) => {
                photo = data
            });
            await fetch(photo).then((response) => {
                if (response.status === 200) {
                    let item = {
                        img: photo,
                        name: levelName,
                        animal: animalName,
                        coin: 0
                    };

                    // Update the boughts array
                    boughts.forEach(existingItem => {
                        if (existingItem.name === levelName) {
                            existingItem.url = photo;
                        }
                    });

                    // Update or add item in the animals array
                    const foundItem = animals.find(existingItem => existingItem.name === levelName);
                    if (foundItem) {
                        foundItem.img = photo;
                    } else {
                        animals.push(item);
                    }

                    // Update the state
                    setBoughts(boughts);
                    setAnimals(animals);
                }
            });
        }
    };
    
    const getAnimals = async () => {
        const animalConfigurations = [
            { levelName: "favorite", unlockedCount: 5, animalName: "fish" },
            { levelName: "feeling", unlockedCount: 6, animalName: "octopus"},
            { levelName: "listening", unlockedCount: 6, animalName: "frog"},
            { levelName: "friends", unlockedCount: 5, animalName: "gnome"},
            { levelName: "solution", unlockedCount: 3, animalName: "owl"},
            { levelName: "conflict", unlockedCount: 5, animalName: "dinosaur"},
            { levelName: "advocacy", unlockedCount: 5, animalName: "sasquatch"},
            { levelName: "community", unlockedCount: 10, animalName: "alien"}
        ];
    
        // Iterate over each animal configuration and call the function
        for (const config of animalConfigurations) {
            try{
                await getAnimalData(config.levelName, config.unlockedCount, config.animalName);
            }
            catch(error){}
        }
        setStoreReady(true);
    };
    
    useEffect(() => {
        const fetchData = async () => {
            let modules = ['favorite', 'feeling', 'listening', 'friends', 'solution', 'conflict', 'advocacy', 'community'];
            
            // Loop through boughts and fetch data if necessary
            for (let item of boughts) {
                if (modules.includes(item.name)) {
                    try {
                        // Await the fetch to check the URL status
                        const response = await fetch(item.url);

                        // If the response is not OK (status !== 200), fetch the new image
                        if (response.status !== 200) {
                            const data = await GetUserVideo(`userfiles/${login.studentid}/level2_${item.name}_animal.png`);
                            item.url = data; // Directly update the URL property
                        }
                    } catch (error) {
                        // In case of an error, attempt to get the video
                        const data = await GetUserVideo(`userfiles/${login.studentid}/level2_${item.name}_animal.png`);
                        item.url = data; // Directly update the URL property
                    }
                }
            }
            
            // After processing all items, update the state with a new reference
            setBoughts([...boughts]); // Trigger re-render with updated state
        };
    
        fetchData();
    }, []);

    useEffect(() => {
        if(displayStore){
            getAnimals();
        }
    }, [displayStore]);
    

    const backgrounds = [generateImageUrl('images/Module6Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+2.png'), 
                         generateImageUrl('images/Module7Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+3.png'),
                         generateImageUrl('images/Module8Images/Module8NavImages/Background_JourneyMap_Unit2_Mod3.png'),
                         generateImageUrl('images/Module9Images/m9-BG-chromebook.png'),
                         generateImageUrl('images/Module10Images/Unit2_Mod5BGupdated.png')]
    const [bgIdx, setBgIdx] = useState(freeplay.level2Decorate.background);

    const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png')
    const greenCheckSound = new Audio(generateImageUrl('media/Module1Videos/button_accept_item.mp3'))
    const Exit = generateImageUrl('images/Images/close.png')
    const coin = generateImageUrl('images/Images/Coin_Empty.png');


    let buys = [
        { img: 'images/Module6Images/DailyReward_YellowFishes.png', name: "FishSchoolYellow", coin: 4 },
        { img: 'images/Module6Images/DailyReward_GreenFishes.png', name: "FishSchoolGreen", coin: 4 },
        { img: 'images/Module6Images/DailyReward_Dolphin.png', name: "Dolphin", coin: 6 },
        { img: 'images/Module6Images/DailyReward_Shark.png', name: "Shark", coin: 8 },
        { img: 'images/Module6Images/DailyReward_SeaweedGreen@3x.png', name: "SeaweedGreen", coin: 4 },
        { img: 'images/Module6Images/DailyReward_SeaweedBrown@3x.png', name: "SeaweedBrown", coin: 4 },
        { img: 'images/Module6Images/DailyReward_BluePearl.png', name: "ClamBlue", coin: 4 },
        { img: 'images/Module6Images/DailyReward_PinkPearl.png', name: "ClamPink", coin: 4 },
        { img: 'images/Module6Images/DailyReward_CoralRed.png', name: "CoralRed", coin: 4 },
        { img: 'images/Module6Images/DailyReward_CoralBlue.png', name: "CoralBlue", coin: 4 },
        { img: 'images/Module6Images/DailyReward_ShipGreen.png', name: "SunkenShipGreen", coin: 8 },
        { img: 'images/Module6Images/DailyReward_ShipBrown.png', name: "SunkenShip", coin: 8 },
        { img: 'images/Module6Images/DailyReward_CoralGreen.png', name: "CoralGreen", coin: 4 },
        { img: 'images/Module6Images/DailyReward_CoralPurple.png', name: "CoralPurple", coin: 4 },
        { img: 'images/Module6Images/DailyReward_Mermaid1.png', name: "MermaidBlue", coin: 6 },
        { img: 'images/Module6Images/DailyReward_Mermaid2.png', name: "MermaidRed", coin: 6 },
        { img: 'images/newDesign/FreePlay/rewards/BigReward_InsideCir_Castle.png', name: "SandCastle", coin: 10 },
        { img: 'images/Module6Images/BigReward_Treasure.svg', name: "Treasure", coin: 12 },
        { img: 'images/Module7Images/DailyReward_Gnome1.png', name: "GnomeBlue", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Crystal_Blue.png', name: "CrystalBlue", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Flower_Pink.png', name: "FlowerPink", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Flower_Blue.png', name: "FlowerBlue", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Fairy1.png', name: "FairyPurple", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Crystal_Pink.png', name: "CrystalPurple", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Fireflies_Pink.png', name: "FireflyPink", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Frog_Crown2.png', name: "CrownRound", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Fairy2.png', name: "FairyGreen", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Fireflies_Orange.png', name: "FireflyOrange", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Mushrooms_Blue.png', name: "MushroomBlue", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Mushrooms_Purple.png', name: "MushroomPurple", coin: 4 },
        { img: 'images/Module7Images/DailyReward_MossyRock.png', name: "Rock", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Log2.png', name: "Log", coin: 4 },
        { img: 'images/Module7Images/DailyReward_Gnome2.png', name: "GnomeGreen", coin: 6 },
        { img: 'images/Module7Images/DailyReward_Frog_Crown1.png', name: "CrownSpike", coin: 6 },
        { img: 'images/Module7Images/BigReward_Fae_Dragon.png', name: "FaeDragon", coin: 12 },
        { img: 'images/Module7Images/BigReward_Fae_House.png', name: "FaeHouse", coin: 10 },
        { img: 'images/Module8Images/DailyReward_Tree_2.png', name: "Tree2", coin: 8 },
        { img: 'images/Module8Images/DailyReward_Stego_Blue.png', name: "StegoBlue", coin: 6 },
        { img: 'images/Module8Images/DailyReward_DinoLongNeck_Green.png', name: "LongNeckGreen", coin: 8 },
        { img: 'images/Module8Images/DailyReward_DinoLongNeck_Red.png', name: "LongNeckRed", coin: 8 },
        { img: 'images/Module8Images/DailyReward_Raptor_LightBlue.png', name: "RaptorLight", coin: 6 },
        { img: 'images/Module8Images/DailyReward_Stego_Green.png', name: "StegoGreen", coin: 6 },
        { img: 'images/Module8Images/DailyReward_DinoEggs_green.png', name: "EggsGreen", coin: 6 },
        { img: 'images/Module8Images/DailyReward_DinoFlying_Green.png', name: "DinoFlyingGreen", coin: 8 },
        { img: 'images/Module8Images/DailyReward_Raptor_Darker.png', name: "RaptorDark", coin: 8 },
        { img: 'images/Module8Images/DailyReward_DinoEggs_blue.png', name: "EggsBlue", coin: 6 },
        { img: 'images/Module8Images/DailyReward_Dino_Orange.png', name: "DinoOrange", coin: 6 },
        { img: 'images/Module8Images/DailyReward_Dino_Green.png', name: "DinoGreen", coin: 6 },
        { img: 'images/Module8Images/DailyReward_Plant1.png', name: "Plant1", coin: 4 },
        { img: 'images/Module8Images/DailyReward_Plant2.png', name: "Plant2", coin: 4 },
        { img: 'images/Module8Images/DailyReward_Tree_1.png', name: "Tree1", coin: 8 },
        { img: 'images/Module8Images/DailyReward_DinoFlying_Purple.png', name: "DinoFlyingPurple", coin: 8 },
        { img: 'images/newDesign/Unit2Module8/BigRewardVolcanoNoSmoke.png', name: "Volcano", coin: 10 },
        { img: 'images/Module8Images/BigReward_TRex@2x.png', name: "TRex", coin: 12 },
        { img: 'images/Module9Images/DailyReward_Waterfall2@3x.png', name: "Waterfall2", coin: 8 },
        { img: 'images/Module9Images/DailyReward_Horse2.png', name: "Horse2", coin: 6 },
        { img: 'images/Module9Images/DailyReward_Sytar1.png', name: "Sytar1", coin: 10 },
        { img: 'images/Module9Images/DailyReward_Sytar2.png', name: "Sytar2", coin: 10 },
        { img: 'images/Module9Images/DailyReward_Hat1.png', name: "Hat1", coin: 8 },
        { img: 'images/Module9Images/DailyReward_Horse1.png', name: "Horse1", coin: 6 },
        { img: 'images/Module9Images/DailyReward_Owl2.png', name: "Owl2", coin: 4 },
        { img: 'images/Module9Images/DailyReward_Pheonix.png', name: "Pheonix", coin: 8 },
        { img: 'images/Module9Images/DailyReward_Hat2.png', name: "Hat2", coin: 8 },
        { img: 'images/Module9Images/DailyReward_Owl1.png', name: "Owl1", coin: 4 },
        { img: 'images/Module9Images/DailyReward_Yeti_Brown.png', name: "YetiBrown", coin: 6 },
        { img: 'images/Module9Images/DailyReward_Yeti.png', name: "Yeti", coin: 6 },
        { img: 'images/Module9Images/DailyReward_Bluejay.png', name: "Bluejay", coin: 4 },
        { img: 'images/Module9Images/DailyReward_Woodpecker.png', name: "Woodpecker", coin: 4 },
        { img: 'images/Module9Images/DailyReward_Waterfall1@3x.png', name: "Waterfall1", coin: 8 },
        { img: 'images/Module9Images/DailyReward_Dragon.png', name: "Dragon", coin: 8 },
        { img: 'images/Module9Images/BigReward_Castle.png', name: "MedievalCastle", coin: 12 },
        { img: 'images/Module10Images/DailyReward_CometOrange.png', name: "CometOrange", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Alien2.png', name: "Alien2", coin: 6 },
        { img: 'images/Module10Images/DailyReward_Planet1.png', name: "Planet1", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Planet2.png', name: "Planet2", coin: 8 },
        { img: 'images/Module10Images/DailyReward_SpaceHelment1.png', name: "Helmet1", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Alien1.png', name: "Alien1", coin: 6 },
        { img: 'images/Module10Images/DailyReward_SpaceHelment2.png', name: "Helmet2", coin: 8 },
        { img: 'images/Module10Images/DailyReward_UFO2.png', name: "UFO2", coin: 8 },
        { img: 'images/Module10Images/DailyReward_UFO1.png', name: "UFO1", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Rocket1.png', name: "Rocket1", coin: 8 },
        { img: 'images/Module10Images/DailyReward_Rocket2.png', name: "Rocket2", coin: 8 },
        { img: 'images/Module10Images/DailyReward_CometBlue.png', name: "CometBlue", coin: 8 },
        { img: 'images/Module10Images/BigReward_Galaxy.png', name: "Galaxy", coin: 12 },
      ];
      
      
    buys = buys.sort((a, b) => a.coin - b.coin);

    const [boughts, setBoughts] = useState(freeplay.level2Decorate.items);

    const [update, setUpdate] = useState(false);


    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
        } else {
            updateFreeplay();
        }
    }, [freeplay.level2Coin, freeplay.level2, update]);

    const setConversation = (num, name) => {
        document.querySelectorAll('.option').forEach(function(element) {
            element.style.border= '';
        })
        let element = document.getElementsByClassName('option')[num]
        element.style.border= '2px solid yellow';
        setConversationName(name);
        setConversationNum(num);
        chooseConversation(num);
    }

    const settopic = (num) => {
        document.querySelectorAll('.option').forEach(function(element) {
            element.style.border= '';
        })
        let element = document.getElementsByClassName('option')[num]
        element.style.border= '2px solid yellow';
        chooseTopic(num)
    }

    const chooseConversation = (conversationPlay) => {
        setDisplayStep1(false)
        let topics = [];
        switch(conversationPlay){
            case 0:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/color.png'),
                        text: "Color",
                        completed: freeplay.level2.favorite.color.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/animal.png'),
                        text: "Animal",
                        completed: freeplay.level2.favorite.animal.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/food.png'),
                        text: "Food",
                        completed: freeplay.level2.favorite.food.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/game.png'),
                        text: "Game",
                        completed: freeplay.level2.favorite.game.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/outside.png'),
                        text: "Thing to do outside",
                        completed: freeplay.level2.favorite.thing.unlocked

                    }
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/greet/greet_celebrate_record_awesome.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I am awesome!"')
                if (Object.values(freeplay.level2.favorite).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.favorite).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 1:
                topics = [
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Happy_resized.png"),
                        text: "Happy",
                        completed: freeplay.level2.feeling.happy.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Sad_resized.png"),
                        text: "Sad",
                        completed: freeplay.level2.feeling.sad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Calm_resized.png"),
                        text: "Calm",
                        completed: freeplay.level2.feeling.calm.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Mad_resized.png"),
                        text: "Mad",
                        completed: freeplay.level2.feeling.mad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Confident_resized.png"),
                        text: "Confident",
                        completed: freeplay.level2.feeling.confident.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Nervous_resized.png"),
                        text: "Nervous",
                        completed: freeplay.level2.feeling.nervous.unlocked

                    },
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/answer/answer_celebrate_record_amazing.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I am amazing!"')
                if (Object.values(freeplay.level2.feeling).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.feeling).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 2:
                topics = [
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Happy_resized.png"),
                        text: "Happy",
                        completed: freeplay.level2.listening.happy.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Sad_resized.png"),
                        text: "Sad",
                        completed: freeplay.level2.listening.sad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Calm_resized.png"),
                        text: "Calm",
                        completed: freeplay.level2.listening.calm.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Mad_resized.png"),
                        text: "Mad",
                        completed: freeplay.level2.listening.mad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Confident_resized.png"),
                        text: "Confident",
                        completed: freeplay.level2.listening.confident.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Nervous_resized.png"),
                        text: "Nervous",
                        completed: freeplay.level2.listening.nervous.unlocked

                    },
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/close/close_celebrate_record_believe.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I believe in me!"')
                if (Object.values(freeplay.level2.listening).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.listening).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 3:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/favorite_subject.png'),
                        text: "Favorite subject in school",
                        completed: freeplay.level2.friends.subject.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/outside.png'),
                        text: "Outside",
                        completed: freeplay.level2.friends.outside.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/animal.png'),
                        text: "Animal",
                        completed: freeplay.level2.friends.animal.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/food.png'),
                        text: "Food",
                        completed: freeplay.level2.friends.food.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/favorite_fun.png'),
                        text: "What you like to do for fun",
                        completed: freeplay.level2.friends.fun.unlocked

                    },
                ];
                setTopics(topics);
                if (Object.values(freeplay.level2.friends).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.friends).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 4:
                topics = [
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Sad_resized.png"),
                        text: "Sad",
                        completed: freeplay.level2.solution.sad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Mad_resized.png"),
                        text: "Mad",
                        completed: freeplay.level2.solution.mad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Nervous_resized.png"),
                        text: "Nervous",
                        completed: freeplay.level2.solution.nervous.unlocked

                    },
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/respond/respond_celebrate_record_do_all.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I can do it all!"')
                if (Object.values(freeplay.level2.solution).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.solution).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 5:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/seat_taken.png'),
                        text: "Seat Taken",
                        completed: freeplay.level2.conflict.seat.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/dino_toy.png'),
                        text: "Dislike Toy",
                        completed: freeplay.level2.conflict.shop.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/shovel.png'),
                        text: "Stole Shovel",
                        completed: freeplay.level2.conflict.shovel.unlocked

                    },
                    {
                        img: generateImageUrl('images/Module8Images/Module8NavImages/JourneyMap_Mod3_Day8.png'),
                        text: "Blocking View",
                        completed: freeplay.level2.conflict.stand.unlocked

                    },
                    {
                        img: generateImageUrl('images/Module4Images/Reward_Camera.png'),
                        text: "Bumped Into",
                        completed: freeplay.level2.conflict.photo.unlocked

                    },
                ];
                setTopics(topics);
                if (Object.values(freeplay.level2.conflict).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.conflict).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 6:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/feed_birds.png'),
                        text: "Feed the Birds",
                        completed: freeplay.level2.advocacy.bird.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/buy_tickets.png'),
                        text: "Buy a Ticket",
                        completed: freeplay.level2.advocacy.train.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/ask_monkey.png'),
                        text: "Ask a Question",
                        completed: freeplay.level2.advocacy.monkey.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/teacher.jpg'),
                        text: "Ask for Teacher",
                        completed: freeplay.level2.advocacy.care.unlocked 

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/ask_napkin.png'),
                        text: "Ask for Napkin",
                        completed: freeplay.level2.advocacy.snack.unlocked

                    }
                ];
                setTopics(topics);
                if (Object.values(freeplay.level2.advocacy).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.advocacy).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 7:
                // Objects to be pushed into the array
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/snow_cone.png'),
                        text: "Snow Cone Stand",
                        completed: freeplay.level2.community.cone.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/beach_topics.png'),
                        text: "Beach",
                        completed: freeplay.level2.community.guard.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/theme_park_topic.png'),
                        text: "Theme Park",
                        completed: freeplay.level2.community.wheel.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/arcade_topic.png'),
                        text: "Arcade",
                        completed: freeplay.level2.community.arcade.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/fast_food_topic.png'),
                        text: "Fast Food",
                        completed: freeplay.level2.community.food.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/saloon_topic.png'),
                        text: "Salon",
                        completed: freeplay.level2.community.salon.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/clothing_topic.png'),
                        text: "Clothing Store",
                        completed: freeplay.level2.community.clothing.unlocked
                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/bakery_topic.png'),
                        text: "Bakery",
                        completed: freeplay.level2.community.bakery.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/groceries_topic.png'),
                        text: "Grocery Store",
                        completed: freeplay.level2.community.grocery.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/cinema_topic.png'),
                        text: "Movie Theater",
                        completed: freeplay.level2.community.theater.unlocked

                    },
                ];
                setTopics(topics);
                if (Object.values(freeplay.level2.community).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.community).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            default:
                break;
        }
        setDisplayStep2(true)
        // setDisplayGame(true)
    }

    const chooseTopic = (topicPlay) => {
        setDisplayStep2(false);
        let name = '';
        let instructions = [];
        let texts = [];
        let conversations = [];
        let order = [];
        let order9 = [];
        let order10 = [];
        let exampleVideos = [];
        let codes = [];
        let celebrateAudios = [];
        let celebrateTexts = [];
        switch(conversationNum){
            case 0:
                name = 'Favorite Things'
                instructions = [
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your favorite color. My favorite color is`,
                        `Choose your favorite color. My favorite color is`,
                        `Choose your response`,
                        `Choose your response`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your favorite animal. My favorite animal is`,
                        `Choose your favorite animal. My favorite animal is`,
                        `Choose your response`,
                        `Choose your response`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your favorite food. My favorite food is`,
                        `Choose your favorite food. My favorite food is`,
                        `Choose your response`,
                        `Choose your response`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your favorite game. My favorite game is`,
                        `Choose your favorite game. My favorite game is`,
                        `Choose your response`,
                        `Choose your response`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your favorite thing to do outside. My favorite thing to do outside is`,
                        `Choose your favorite thing to do outside. My favorite thing to do outside is`,
                        `Choose your response`,
                        `Choose your response`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                ];
                texts = [
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'blue.',
                            'red.',
                            'purple.',
                            'yellow.',
                            'green.',
                            '[say your own choice].' 
                        ],
                        [
                            'blue.',
                            'red.',
                            'purple.',
                            'yellow.',
                            'green.',
                            '[say your own choice].' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Pretty!' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Pretty!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'a dog.',
                            'a cat.',
                            'a horse.',
                            'a bird.',
                            'a monkey.',
                            '[say your own choice].' 
                        ],
                        [
                            'a dog.',
                            'a cat.',
                            'a horse.',
                            'a bird.',
                            'a monkey.',
                            '[say your own choice].' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Pretty!' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Pretty!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'salad.',
                            'chicken nuggets.',
                            'pizza.',
                            'spaghetti.',
                            'hamburger.',
                            '[say your own choice].' 
                        ],
                        [
                            'salad.',
                            'chicken nuggets.',
                            'pizza.',
                            'spaghetti.',
                            'hamburger.',
                            '[say your own choice].' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Yummy!' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Yummy!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'checkers.',
                            'card games.',
                            'board games.',
                            'tag.',
                            'video games.',
                            '[say your own choice].' 
                        ],
                        [
                            'checkers.',
                            'card games.',
                            'board games.',
                            'tag.',
                            'video games.',
                            '[say your own choice].' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Fun!' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Fun!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'swim.',
                            'play sports.',
                            'run.',
                            'tag.',
                            'ski.',
                            '[say your own choice].' 
                        ],
                        [
                            'swim.',
                            'play sports.',
                            'run.',
                            'tag.',
                            'ski.',
                            '[say your own choice].' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Fun!' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Fun!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ]
                    ],
                ];
                conversations = [
                    [
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: What is your favorite color?", sender: "friend" },
                        { text: "You: My favorite color is ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: What is your favorite color?", sender: "student" },
                        { text: "Your friend: My favorite color is ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" }
                    ],
                    [
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: What is your favorite animal?", sender: "friend" },
                        { text: "You: My favorite animal is ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: What is your favorite animal?", sender: "student" },
                        { text: "Your friend: My favorite animal is ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" }
                    ],
                    [
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: What is your favorite food?", sender: "friend" },
                        { text: "You: My favorite food is ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: What is your favorite food?", sender: "student" },
                        { text: "Your friend: My favorite food is ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" }
                    ],
                    [
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: What is your favorite game?", sender: "friend" },
                        { text: "You: My favorite game is ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: What is your favorite game?", sender: "student" },
                        { text: "Your friend: My favorite game is ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" }
                    ],
                    [
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: What is your favorite thing to do outside?", sender: "friend" },
                        { text: "You: My favorite thing to do outside is ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: What is your favorite thing to do outside?", sender: "student" },
                        { text: "Your friend: My favorite thing to do outside is ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" }
                    ],
                ];
                

                order = [1, 0, 3, 6, 7, 4, 9, 8];

                exampleVideos = [
                    'appfiles/freeplay/favorite/demo_color.mp4',
                    'appfiles/freeplay/favorite/demo_animal.mp4',
                    'appfiles/freeplay/favorite/demo_food.mp4',
                    'appfiles/freeplay/favorite/demo_game.mp4',
                    'appfiles/freeplay/favorite/demo_outside.mp4',
                ];
                codes = [
                    'COLOR',
                    'ANIMAL',
                    'FOOD',
                    'GAME',
                    'THING',
                ];
                setTopicName(`FAVORITE_${codes[topicPlay]}`)
                setCompletePrompt(`FREEPLAY_SET_LEVEL2_FAVORITE_${codes[topicPlay]}`)
                break;
            case 1:
                name = 'Talk about Feelings'
                instructions = [
                    [
                        `Choose what makes you feel happy. I feel happy when I`,
                        `Choose a response`,
                    ],
                    [
                        `Choose what makes you feel sad. I feel sad when I`,
                        `Choose a response`,
                    ],
                    [
                        `Choose what makes you feel calm. I feel calm when I`,
                        `Choose a response`,
                    ],
                    [
                        `Choose what makes you feel mad. I feel mad when I`,
                        `Choose a response`,
                    ],
                    [
                        `Choose what makes you feel confident. I feel confident when I`,
                        `Choose a response`,
                    ],
                    [
                        `Choose what makes you feel nervous. I feel nervous when `,
                        `Choose a response`,
                    ]
                ];
                texts = [
                    [
                        [
                            'ride my bike.',
                            'swim.',
                            'smile.',
                            'play with friends.',
                            'exercise.',
                            '[say your own choice].'
                        ],
                        [
                            'I am glad that makes you feel happy!',
                            'That makes me happy too!',
                            'I love that choice!',
                            'Awesome!',
                            'I am glad you feel happy when you (what was said)!',
                            '[say your own choice].'
                        ]
                    ],
                    [
                        [
                            'break my toy.',
                            'do not get along with others.',
                            'make a mistake.',
                            'get hurt.',
                            'cannot play outside.',
                            '[say your own choice].'
                        ],
                        [
                            'I am sorry that makes you feel sad.',
                            'That makes me sad too.',
                            'I am sorry.',
                            'I feel sad about that too.',
                            'I am sorry you feel sad when you (what was said).',
                            '[say your own choice].'
                        ]
                    ],
                    [
                        [
                            'listen to music.',
                            'eat.',
                            'take a nap.',
                            'take deep breaths.',
                            'exercise.',
                            '[say your own choice].'
                        ],
                        [
                            'I am glad that makes you feel calm!',
                            'That makes me feel calm too!',
                            'I like that idea!',
                            'I feel calm when I do that too!',
                            'I am glad you feel calm when you (what was said)!',
                            '[say your own choice].'
                        ],
                    ],
                    [
                        [
                            'break my toy.',
                            'am tired.',
                            'cannot play my game.',
                            'am hungry.',
                            'cannot play outside.',
                            '[say your own choice].'
                        ],
                        [
                            'I am sorry that makes you feel mad.',
                            'That makes me mad too.',
                            'I am sorry.',
                            'I can understand why you’d feel mad.',
                            'I am sorry you feel mad when you (what was said).',
                            '[say your own choice].'
                        ]
                    ],
                    [
                        [
                            'try something new.',
                            'do hard things.',
                            'make a new friend. ',
                            'stand tall.',
                            'work hard.',
                            '[say your own choice].'
                        ],
                        [
                            'I am glad that makes you feel confident!',
                            'That makes me confident too!',
                            'I am so happy for you!',
                            'I feel confident about that too!',
                            'I am glad you feel confident when you (what was said)!',
                            '[say your own choice].'
                        ]
                    ],
                    [
                        [
                            'something is new to me.',
                            'it is dark.',
                            'I have a test.',
                            'I have to talk in front of others.',
                            'I meet someone new.',
                            '[say your own choice].'
                        ],
                        [
                            'I am sorry that makes you feel nervous.',
                            'That makes me nervous too.',
                            'I am sorry.',
                            'I feel nervous about that too.',
                            'I am sorry you feel nervous when you (what was said).',
                            '[say your own choice].'
                        ]
                    ],
                ];
                conversations = [
                    [
                        { text: "Your friend: What makes you feel happy?", sender: "friend" },
                        { text: "You:  I feel happy when I ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: Awesome!", sender: "student" },
                    ],
                    [
                        { text: "Your friend: What makes you feel sad?", sender: "friend" },
                        { text: "You:  I feel sad when I ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: Thank you!", sender: "student" },
                    ],
                    [
                        { text: "Your friend: What makes you feel calm?", sender: "friend" },
                        { text: "You:  I feel calm when I ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: Awesome!", sender: "student" },
                    ],
                    [
                        { text: "Your friend: What makes you feel mad?", sender: "friend" },
                        { text: "You:  I feel mad when I ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: Thank you!", sender: "student" },
                    ],
                    [
                        { text: "Your friend: What makes you feel confident?", sender: "friend" },
                        { text: "You:  I feel confident when I ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: Awesome!", sender: "student" },
                    ],
                    [
                        { text: "Your friend: What makes you feel nervous?", sender: "friend" },
                        { text: "You:  I feel nervous when ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: Thank you!", sender: "student" },
                    ],
                ];
                

                order = [1, 2];

                exampleVideos = [
                    'appfiles/freeplay/favorite/demo_color.mp4',
                    'appfiles/freeplay/favorite/demo_animal.mp4',
                    'appfiles/freeplay/favorite/demo_food.mp4',
                    'appfiles/freeplay/favorite/demo_game.mp4',
                    'appfiles/freeplay/favorite/demo_outside.mp4',
                ];
                codes = [
                    'HAPPY',
                    'SAD',
                    'CALM',
                    'MAD',
                    'CONFIDENT',
                    'NERVOUS'
                ];
                setTopicName(`FEELING_${codes[topicPlay]}`)
                setCompletePrompt(`FREEPLAY_SET_LEVEL2_FEELING_${codes[topicPlay]}`)
                break;
            case 2:
                name = 'Active Listening'
                instructions = [
                    [
                        `Choose what feeling you would like to ask your friend. What makes you feel`,
                        `Choose what makes you feel (happy, cheerful, joyful). I feel (happy, cheerful, joyful) when I`,
                        `Choose a response`
                    ],
                    [
                        `Choose what feeling you would like to ask your friend. What makes you feel`,
                        `Choose what makes you feel (sad, unhappy, miserable). I feel (sad, unhappy, miserable) when I`,
                        `Choose a response`,
                    ],
                    [
                        `Choose what feeling you would like to ask your friend. What makes you feel`,
                        `Choose what makes you feel (calm, peaceful, quiet). I feel (calm, peaceful, quiet) when I`,
                        `Choose a response`,
                    ],
                    [
                        `Choose what feeling you would like to ask your friend. What makes you feel`,
                        `Choose what makes you feel (mad, angry, furious). I feel (mad, angry, furious) when I`,
                        `Choose a response`,
                    ],
                    [
                        `Choose what feeling you would like to ask your friend. What makes you feel`,
                        `Choose what makes you feel (confident, positive, cool). I feel (confident, positive, cool) when I`,
                        `Choose a response`,
                    ],
                    [
                        `Choose what feeling you would like to ask your friend. What makes you feel`,
                        `Choose what makes you feel (nervous, anxious, jumpy). I feel (nervous, anxious, jumpy) when I`,
                        `Choose a response`,
                    ]
                ];
                texts = [
                    [
                        [
                            'happy?',
                            'cheerful?',
                            'joyful?'
                        ],
                        [
                            'ride my bike.',
                            'swim.',
                            'smile.',
                            'play with friends.',
                            'exercise.',
                            '[say your own choice].'
                        ],
                        [
                            'I am glad that makes you feel happy!',
                            'That makes me happy too!',
                            'I love that choice!',
                            'I feel happy when I do that too!',
                            'I am glad you feel happy when you (what was said)!',
                            '[say your own choice].'
                        ],
                    ],
                    [
                        [
                            'sad?',
                            'unhappy?',
                            'miserable?'
                        ],
                        [
                            'break my toy.',
                            'do not get along with others.',
                            'make a mistake.',
                            'get hurt.',
                            'cannot play outside.',
                            '[say your own choice].'
                        ],
                        [
                            'I am sorry that makes you feel sad.',
                            'That makes me sad too.',
                            'I am sorry.',
                            'I feel sad about that too.',
                            'I am sorry you feel sad when you (what was said).',
                            '[say your own choice].'
                        ],
                    ],
                    [
                        [
                            'calm?',
                            'peaceful?',
                            'quiet?'
                        ],
                        [
                            'listen to music.',
                            'eat.',
                            'take a nap.',
                            'take deep breaths.',
                            'exercise.',
                            '[say your own choice].'
                        ],
                        [
                            'I am glad that makes you feel calm!',
                            'That makes me feel calm too!',
                            'I like that idea!',
                            'I feel calm when I do that too!',
                            'I am glad you feel calm when you (what was said)!',
                            '[say your own choice].'
                        ],

                    ],
                    [
                        [
                            'mad?',
                            'angry?',
                            'furious?'
                        ],
                        [
                            'break my toy.',
                            'am tired.',
                            'cannot play my game.',
                            'am hungry.',
                            'cannot play outside.',
                            '[say your own choice].'
                        ],
                        [
                            'I am sorry that makes you feel mad.',
                            'That makes me mad too.',
                            'I am sorry.',
                            'I can understand why you’d feel mad.',
                            'I am sorry you feel mad when you (what was said).',
                            '[say your own choice].'
                        ],
                    ],
                    [
                        [
                            'confident?',
                            'positive?',
                            'cool?'
                        ],
                        [
                            'try something new.',
                            'do hard things.',
                            'make a new friend. ',
                            'stand tall.',
                            'work hard.',
                            '[say your own choice].'
                        ],
                        [
                            'I am glad that makes you feel confident!',
                            'That makes me confident too!',
                            'I am so happy for you!',
                            'I feel confident about that too!',
                            'I am glad you feel confident when you (what was said)!',
                            '[say your own choice].'
                        ],

                    ],
                    [
                        [
                            'nervous?',
                            'anxious?',
                            'jumpy?'
                        ],
                        [
                            'something is new to me.',
                            'it is dark.',
                            'I have a test.',
                            'I have to talk in front of others.',
                            'I meet someone new.',
                            '[say your own choice].'
                        ],
                        [
                            'I am sorry that makes you feel nervous.',
                            'That makes me nervous too.',
                            'I am sorry.',
                            'I feel nervous about that too.',
                            'I am sorry you feel nervous when you (what was said).',
                            '[say your own choice].'
                        ],
                    ],
                ];
                conversations = [
                    [
                        { text: "You: What makes you feel ", sender: "student" },
                        { text: "Your friend: I feel happy when I ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: Thank you!", sender: "friend" },
                    ],
                    [
                        { text: "You: What makes you feel ", sender: "student" },
                        { text: "Your friend: I feel sad when I ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: Thank you!", sender: "friend" },
                    ],
                    [
                        { text: "You: What makes you feel ", sender: "student" },
                        { text: "Your friend: I feel calm when I ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: Thank you!", sender: "friend" },
                    ],
                    [
                        { text: "You: What makes you feel ", sender: "student" },
                        { text: "Your friend: I feel mad when I ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: Thank you!", sender: "friend" },
                    ],
                    [
                        { text: "You: What makes you feel ", sender: "student" },
                        { text: "Your friend: I feel confident when I ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: Thank you!", sender: "friend" },
                    ],
                    [
                        { text: "You: What makes you feel ", sender: "student" },
                        { text: "Your friend: I feel nervous when ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: Thank you!", sender: "friend" },
                    ],
                ];
                
                order = [0, 1, 2];

                exampleVideos = [
                    'appfiles/freeplay/favorite/demo_color.mp4',
                    'appfiles/freeplay/favorite/demo_animal.mp4',
                    'appfiles/freeplay/favorite/demo_food.mp4',
                    'appfiles/freeplay/favorite/demo_game.mp4',
                    'appfiles/freeplay/favorite/demo_outside.mp4',
                ];
                codes = [
                    'HAPPY',
                    'SAD',
                    'CALM',
                    'MAD',
                    'CONFIDENT',
                    'NERVOUS'
                ];
                setTopicName(`LISTENING_${codes[topicPlay]}`)
                setCompletePrompt(`FREEPLAY_SET_LEVEL2_LISTENING_${codes[topicPlay]}`)
                break;
            case 3:
                name = 'Making Friends'
                instructions = [
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your favorite subject in school. My favorite subject is`,
                        `Choose your favorite subject in school. My favorite subject is`,
                        `Choose your response`,
                        `Choose your response`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your favorite thing to do outside. My favorite thing to do outside is`,
                        `Choose your favorite thing to do outside. My favorite thing to do outside is`,
                        `Choose your response`,
                        `Choose your response`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your favorite animal. My favorite animal is a`,
                        `Choose your favorite animal. My favorite animal is a`,
                        `Choose your response`,
                        `Choose your response`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your favorite food. My favorite food is`,
                        `Choose your favorite food. My favorite food is`,
                        `Choose your response`,
                        `Choose your response`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose what you like to do for fun. I like to`,
                        `Choose what you like to do for fun. I like to`,
                        `Choose your response`,
                        `Choose your response`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                ];
                texts = [
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'history.',
                            'science.',
                            'math.',
                            'language arts.',
                            'P.E.',
                            '[say your own choice].' 
                        ],
                        [
                            'history.',
                            'science.',
                            'math.',
                            'language arts.',
                            'P.E.',
                            '[say your own choice].' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            '[Say your own choice]' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            '[Say your own choice]' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'swim.',
                            'play sports.',
                            'run.',
                            'tag.',
                            'ski.',
                            '[say your own choice].' 
                        ],
                        [
                            'swim.',
                            'play sports.',
                            'run.',
                            'tag.',
                            'ski.',
                            '[say your own choice].' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Fun!' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Fun!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'a dog.',
                            'a cat.',
                            'a horse.',
                            'a bird.',
                            'a monkey.',
                            '[say your own choice].' 
                        ],
                        [
                            'a dog.',
                            'a cat.',
                            'a horse.',
                            'a bird.',
                            'a monkey.',
                            '[say your own choice].' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Fun!' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Fun!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'salad.',
                            'chicken nuggets.',
                            'pizza.',
                            'spaghetti.',
                            'hamburger.',
                            '[say your own choice].' 
                        ],
                        [
                            'salad.',
                            'chicken nuggets.',
                            'pizza.',
                            'spaghetti.',
                            'hamburger.',
                            '[say your own choice].' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Yummy!' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Yummy!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!'
                        ],
                        [
                            'sing.',
                            'play soccer.',
                            'draw.',
                            'read.',
                            'play baseball.',
                            '[say your own choice].' 
                        ],
                        [
                            'sing.',
                            'play soccer.',
                            'draw.',
                            'read.',
                            'play baseball.',
                            '[say your own choice].' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Fun!' 
                        ],
                        [
                            'Cool!',
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Fun!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!' 
                        ]
                    ],
                ];
                conversations = [
                    [
                        {text: "Step 1: Be Kind", sender: "step"},
                        { text: "You: ", sender: "student" },
                        { text: "You: What is your name?", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: My name is (say your name).", sender: "friend" },
                        {text: "Step 2: Ask Questions", sender: "step"},
                        { text: "You: What is your favorite subject in school?", sender: "student" },
                        { text: "Your friend: My favorite subject is ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: What is your favorite subject in school?", sender: "friend" },
                        { text: "You: My favorite subject is ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        {text: "Bonus: Tell your friend the 3 steps to stop bullying", sender: "step"},
                        { text: "Your friend: Tell me the 3 steps to stop bullying.", sender: "friend" },
                        { text: "You: Step 1: Tell the bully to stop.", sender: "student" },
                        { text: "You: Step 2: Walk away and stay away.", sender: "student" },
                        { text: "You: Step 3: Tell a safe adult.", sender: "student" },
                    ],
                    [
                        {text: "Step 1: Be Kind", sender: "step"},
                        { text: "You: ", sender: "student" },
                        { text: "You: What is your name?", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: My name is (say your name), thank you for asking.", sender: "friend" },
                        {text: "Step 2: Ask Questions", sender: "step"},
                        { text: "You: What is your favorite thing to do outside?", sender: "student" },
                        { text: "Your friend: My favorite thing to do outside is ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: What is your favorite thing to do outside?", sender: "friend" },
                        { text: "You: My favorite thing to do outside is ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        {text: "Bonus: Tell your friend the 3 steps to stop bullying", sender: "step"},
                        { text: "Your friend: Tell me the 3 steps to stop bullying.", sender: "friend" },
                        { text: "You: Step 1: Tell the bully to stop.", sender: "student" },
                        { text: "You: Step 2: Walk away and stay away.", sender: "student" },
                        { text: "You: Step 3: Tell a safe adult.", sender: "student" },
                    ],
                    [
                        {text: "Step 1: Be Kind", sender: "step"},
                        { text: "You: ", sender: "student" },
                        { text: "You: What is your name?", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: My name is (say your name).", sender: "friend" },
                        {text: "Step 2: Ask Questions", sender: "step"},
                        { text: "You: What is your favorite animal?", sender: "student" },
                        { text: "Your friend: My favorite animal is ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: What is your favorite animal?", sender: "friend" },
                        { text: "You: My favorite animal is ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        {text: "Bonus: Tell your friend the 3 steps to stop bullying", sender: "step"},
                        { text: "Your friend: Tell me the 3 steps to stop bullying.", sender: "friend" },
                        { text: "You: Step 1: Tell the bully to stop.", sender: "student" },
                        { text: "You: Step 2: Walk away and stay away.", sender: "student" },
                        { text: "You: Step 3: Tell a safe adult.", sender: "student" },
                    ],
                    [
                        {text: "Step 1: Be Kind", sender: "step"},
                        { text: "You: ", sender: "student" },
                        { text: "You: What is your name?", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: My name is (say your name), thank you for asking.", sender: "friend" },
                        {text: "Step 2: Ask Questions", sender: "step"},
                        { text: "You: What is your favorite food?", sender: "student" },
                        { text: "Your friend: My favorite food is ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: What is your favorite food?", sender: "friend" },
                        { text: "You: My favorite food is ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        {text: "Bonus: Tell your friend the 3 steps to stop bullying", sender: "step"},
                        { text: "Your friend: Tell me the 3 steps to stop bullying.", sender: "friend" },
                        { text: "You: Step 1: Tell the bully to stop.", sender: "student" },
                        { text: "You: Step 2: Walk away and stay away.", sender: "student" },
                        { text: "You: Step 3: Tell a safe adult.", sender: "student" },
                    ],
                    [
                        {text: "Step 1: Be Kind", sender: "step"},
                        { text: "You: ", sender: "student" },
                        { text: "You: What is your name?", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: My name is (say your name), thank you for asking.", sender: "friend" },
                        {text: "Step 2: Ask Questions", sender: "step"},
                        { text: "You: What do you like to do for fun?", sender: "student" },
                        { text: "Your friend: I like to ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: What do you like to do for fun?", sender: "friend" },
                        { text: "You: I like to ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        {text: "Bonus: Tell your friend the 3 steps to stop bullying", sender: "step"},
                        { text: "Your friend: Tell me the 3 steps to stop bullying.", sender: "friend" },
                        { text: "You: Step 1: Tell the bully to stop.", sender: "student" },
                        { text: "You: Step 2: Walk away and stay away.", sender: "student" },
                        { text: "You: Step 3: Tell a safe adult.", sender: "student" },
                    ]
                ];
                
                order = [1, 3, 10, 7, 8, 11, 12, 13];

                exampleVideos = [
                    'appfiles/freeplay/favorite/demo_color.mp4',
                    'appfiles/freeplay/favorite/demo_animal.mp4',
                    'appfiles/freeplay/favorite/demo_food.mp4',
                    'appfiles/freeplay/favorite/demo_game.mp4',
                    'appfiles/freeplay/favorite/demo_outside.mp4',
                ];
                codes = [
                    'SUBJECT',
                    'OUTSIDE',
                    'ANIMAL',
                    'FOOD',
                    'FUN',
                ];
                celebrateAudios = ['appfiles/friends_bullying/friends_bullying_celebrate_record_kind.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_questions.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_not_bully.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_stop_bullying.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_making_friends.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I am amazing because I am kind!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I ask good questions!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I do not bully others!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I tell others to stop bullying!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I am good at making friends!"`]
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                setCompletePrompt(`FREEPLAY_SET_LEVEL2_FRIENDS_${codes[topicPlay]}`)
                setTopicName(`FRIENDS_${codes[topicPlay]}`)
                break;
            case 4:
                name = 'Solutions'
                instructions = [
                    [
                        `What makes you feel sad? I feel sad when I`,
                        `Choose a response`,
                        `What is a solution? I will`,
                        `Choose a response`,
                    ],
                    [
                        `What makes you feel mad? I feel mad when I`,
                        `Choose a response`,
                        `What is a solution? I will`,
                        `Choose a response`,
                    ],
                    [
                        `What makes you feel nervous? I feel nervous when`,
                        `Choose a response`,
                        `What is a solution? I will`,
                        `Choose a response`,
                    ],
                ];
                texts = [
                    [
                        [
                            'break my toy.',
                            'do not get along with others.',
                            'make a mistake.',
                            'get hurt.',
                            'cannot play outside.',
                            '[say your own choice].'
                        ],
                        [
                            'I am sorry that makes you feel sad. What is a solution?',
                            'That makes me sad too. What is a solution?',
                            'I am sorry. How can you make it better?',
                            'I feel sad about that too. What is a solution?',
                            'I am sorry you feel sad when you (what was said). What is a solution?',
                        ],
                        [
                            'take deep breaths.',
                            'stand tall.',
                            'think positive thoughts.',
                            'sing the Joyful Jingle.',
                            'believe in myself.',
                            '[say your own choice].' 
                        ],
                        [
                            'Great solution!',
                            'I like that solution!',
                            'Good job!',
                            'Great idea!',
                            'That is a great way to stay calm!',
                        ],
                    ],
                    [
                        [
                            'break my toy.',
                            'am tired.',
                            'cannot play my game.',
                            'am hungry.',
                            'cannot play outside.',
                            '[say your own choice].'
                        ],
                        [
                            'I am sorry that makes you feel mad. What is a solution?',
                            'That makes me mad too. What is a solution?',
                            'I am sorry. How can you make it better?',
                            'I feel mad about that too. What is a solution?',
                            'I am sorry you feel mad when you (what was said). What is a solution?',
                        ],
                        [
                            'take deep breaths.',
                            'stand tall.',
                            'think positive thoughts.',
                            'sing the Joyful Jingle.',
                            'believe in myself.',
                            '[say your own choice].' 
                        ],
                        [
                            'Great solution!',
                            'I like that solution!',
                            'Good job!',
                            'Great idea!',
                            'That is a great way to stay calm!',
                        ],
                    ],
                    [
                        [
                            'something is new to me.',
                            'it is dark.',
                            'I have a test.',
                            'I have to talk in front of others.',
                            'I meet someone new.',
                            '[say your own choice].'
                        ],
                        [
                            'I am sorry that makes you feel nervous. What is a solution?',
                            'That makes me nervous too. What is a solution?',
                            'I am sorry. How can you make it better?',
                            'I feel nervous about that too. What is a solution?',
                            'I am sorry you feel nervous when you (what was said). What is a solution?',
                        ],
                        [
                            'take deep breaths.',
                            'stand tall.',
                            'not give up.',
                            'sing the Joyful Jingle.',
                            'believe in myself.',
                            '[say your own choice].' 
                        ],
                        [
                            'Great solution!',
                            'I like that solution!',
                            'Good job!',
                            'Great idea!',
                            'That is a great way to stay calm!',
                        ],
                    ],
                ];
                conversations = [
                    [
                        { text: "Your friend: What makes you feel sad?", sender: "friend" },
                        { text: "You: I feel sad when I ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: I will ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                    ],
                    [
                        { text: "Your friend: What makes you feel mad?", sender: "friend" },
                        { text: "You: I feel mad when I ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: I will ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                    ],
                    [
                        { text: "Your friend: What makes you feel nervous?", sender: "friend" },
                        { text: "You: I feel nervous when ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: I will ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                    ],
                ];
                

                order = [1, 2, 3, 4];

                exampleVideos = [
                    'appfiles/freeplay/favorite/demo_color.mp4',
                    'appfiles/freeplay/favorite/demo_animal.mp4',
                    'appfiles/freeplay/favorite/demo_food.mp4',
                    'appfiles/freeplay/favorite/demo_game.mp4',
                    'appfiles/freeplay/favorite/demo_outside.mp4',
                ];
                codes = [
                    'SAD',
                    'MAD',
                    'NERVOUS'
                ];
                setTopicName(`SOLUTION_${codes[topicPlay]}`)
                setCompletePrompt(`FREEPLAY_SET_LEVEL2_SOLUTION_${codes[topicPlay]}`)
                break;
            case 5:
                name = 'Resolve Conflict'
                instructions = [
                    [
                        `You want to sit where your friend is sitting on the bus. How can you make it better?`,
                        `You are sitting where your friend wants to sit. How can you make it better?`,
                    ],
                    [
                        `You feel sad because your friend does not like your toy. How can you make it better?`,
                        `Your friend feels sad because you do not like their toy. How can you make it better?`,
                    ],
                    [
                        `Your friend feels mad because you took the shovel. How can you make it better?`,
                        `You feel mad because your friend took  your shovel. How can you make it better?`,
                    ],
                    [
                        `You are at a museum and you are blocking someone from  seeing the dinosaur. How can you make it better?`,
                        `How can you make it better?`,
                    ],
                    [
                        `You are trying to take a picture and someone bumped into you. How can you make it better`,
                        `How can you make it better?`,
                    ],
                ];
                texts = [
                    [
                        [
                            'I am sorry, I should not tell you to move.',
                            'I can try and sit there next time.',
                            'Can we share the seat?',
                            `It's okay, you can sit there.`,
                            `I need to remember I can't always get what I want.`,
                            '[say your own choice].'
                        ],
                        [
                            'I can save this seat for you tomorrow.',
                            'You can sit here next time.',
                            'We can share the seat.',
                            'You can sit here, I do not mind.',
                            `Let's take turns sitting here.`,
                            '[say your own choice].'
                        ],
                    ],
                    [
                        [
                            "It's okay, we can like different toys.",
                            "We can play with different toys.",
                            "You can try and play with my toy.",
                            "Next time, I will play with your toy.",
                            "Next time, I will try to understand your feelings first.",
                            "[say your own choice]."
                        ],
                        [
                            "I can learn to play with different toys.",
                            "Next time, I can remember to be nicer.",
                            "I would like to play with your toy.",
                            "Next time I will remember What I say can hurt others.",
                            "I will learn to be nicer.",
                            "[say your own choice]."
                        ]
                    ],
                    [
                        [
                            "We can share the shovel.",
                            "I am sorry I got mad at you. We can share the shovel.",
                            "It’s okay, accidents happen.",
                            "Next time, I will remember to not get mad.",
                            "I am sorry. I know you did not do it on purpose.",
                            "[say your own choice]."
                        ],
                        [
                            "We can share the shovel.",
                            "I will give the shovel back to you.",
                            "We can take turns using the shovel.",
                            "Next time, I will remember to ask if someone is using the shovel before I take it.",
                            "Next time, I will be more careful.",
                            "[say your own choice]."
                        ],
                    ],
                    [
                        [
                            "I am sorry, I should not get so mad.",
                            "I can move over so I can see the dinosaur too.",
                            "We can look at the dinosaur together.",
                            "It’s okay, I should have known you did not see me.",
                            "Let's look together.",
                            "[say your own choice]."
                        ],
                        [
                            "I can move over so you can see the dinosaur too.",
                            "We can look at the dinosaur together.",
                            "I will try and be more careful next time.",
                            "It’s okay, I can move now. I am done looking at the dinosaur.",
                            "Let's look together.",
                            "[say your own choice]."
                        ],
                    ],
                    [
                        [
                            "It’s okay, it was an accident.",
                            "I’m sorry, I should not have gotten mad at you.",
                            "I sometimes trip and bump into people too.",
                            "I am sorry I was in your way.",
                            "Accidents happen.",
                            "[say your own choice]."
                        ],
                        [
                            "Next time I will try and be more careful.",
                            "I will try and watch where I am going.",
                            "Thank you for understanding.",
                            "Thank you for listening.",
                            "Let's take a picture together.",
                            "[say your own choice]."
                        ]
                    ]
                ];
                conversations = [
                    [
                        {text: "Step 1: Be Calm", sender: "step"},
                        { text: "You: Take a Deep Breath", sender: "step" },
                        {text: "Step 2: Talk About It", sender: "step"},
                        { text: "You: I am sad because I want to sit where you are sitting.", sender: "student" },
                        { text: "Your friend: I am sorry you feel sad you want to sit here. I was sitting here first.", sender: "friend" },
                        {text: "Step 3: Make It Better", sender: "step"},
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                    ],
                    [
                        {text: "Step 1: Be Calm", sender: "step"},
                        { text: "You: Take a Deep Breath", sender: "step" },
                        {text: "Step 2: Talk About It", sender: "step"},
                        { text: "You: I feel sad you do not like my toy. Can you tell me why?", sender: "student" },
                        { text: "Your friend: I am sorry I made you feel sad because I said I did not like your toy. I did not mean to be rude, but I have never played with that toy before.", sender: "friend" },
                        {text: "Step 3: Make It Better", sender: "step"},
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                    ],
                    [
                        {text: "Step 1: Be Calm", sender: "step"},
                        { text: "You: Take a Deep Breath", sender: "step" },
                        {text: "Step 2: Talk About It", sender: "step"},
                        { text: "You: I feel mad because you took my shovel. Can you tell me why?", sender: "student" },
                        { text: "Your friend: I am sorry I took your shovel. I did not know you were using it.", sender: "friend" },
                        {text: "Step 3: Make It Better", sender: "step"},
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                    ],
                    [
                        {text: "Step 1: Be Calm", sender: "step"},
                        { text: "You: Take a Deep Breath", sender: "step" },
                        {text: "Step 2: Talk About It", sender: "step"},
                        { text: "You: Excuse me, I cannot see the dinosaur.", sender: "student" },
                        { text: "Your friend: I am sorry, I did not see you standing there.", sender: "friend" },
                        {text: "Step 3: Make It Better", sender: "step"},
                        { text: "You: ", sender: "student" }, 
                        { text: "Your friend: ", sender: "friend" },
                    ],
                    [
                        {text: "Step 1: Be Calm", sender: "step"},
                        { text: "You: Take a Deep Breath", sender: "step" },
                        {text: "Step 2: Talk About It", sender: "step"},
                        { text: "You: Please be more careful, I am trying to take a picture.", sender: "student" },
                        { text: "Your friend: Oh, I am so sorry. I tripped and bumped into you.", sender: "friend" },
                        {text: "Step 3: Make It Better", sender: "step"},
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                    ],
                ];
                
                order = [6, 7];

                exampleVideos = [
                    'appfiles/freeplay/favorite/demo_color.mp4',
                    'appfiles/freeplay/favorite/demo_animal.mp4',
                    'appfiles/freeplay/favorite/demo_food.mp4',
                    'appfiles/freeplay/favorite/demo_game.mp4',
                    'appfiles/freeplay/favorite/demo_outside.mp4',
                ];
                codes = [
                    'SEAT',
                    'SHOP',
                    'SHOVEL',
                    'STAND',
                    'PHOTO',
                ];
                celebrateAudios = ['appfiles/resolve_conflict/resolve_conflict_celebrate_calm.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_feelings.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_listener.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_solve_problems.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_better.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I am a very important person because I know when to be calm!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I can talk about my feelings!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I am a good listener!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I solve problems with friends!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I can make things better!"`]
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                setCompletePrompt(`FREEPLAY_SET_LEVEL2_CONFLICT_${codes[topicPlay]}`)
                setTopicName(`CONFLICT_${codes[topicPlay]}`)
                break;
            case 6:
                name = 'Self-Advocacy'
                instructions = [
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                    [
                        `Choose your greeting`,
                        `Choose your greeting`,
                        `Choose your closing`,
                        `Choose your closing`,
                    ],
                ];
                texts = [
                    [
                        [
                            'Hello!',
                            'Hi!',
                            `Good morning!`,
                            `Good afternoon!`,
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            `Good morning!`,
                            `Good afternoon!`,
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            `See you soon!`,
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            `See you soon!`,
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            `Good morning!`,
                            `Good afternoon!`,
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            `Good morning!`,
                            `Good afternoon!`,
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            `See you soon!`,
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            `See you soon!`,
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            `Good morning!`,
                            `Good afternoon!`,
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            `Good morning!`,
                            `Good afternoon!`,
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            `See you soon!`,
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            `See you soon!`,
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            `Good morning!`,
                            `Good afternoon!`,
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            `Good morning!`,
                            `Good afternoon!`,
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            `See you soon!`,
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            `See you soon!`,
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            `Good morning!`,
                            `Good afternoon!`,
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            `Good morning!`,
                            `Good afternoon!`,
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            `See you soon!`,
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            `See you soon!`,
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                    ],

                ];
                conversations = [
                    [
                        {text: "Step 1: Think about what you want to say", sender: "step"},
                        { text: `You: Think about "Can I feed the birds, please?"`, sender: "step" },
                        {text: "Step 2: Believe in yourself", sender: "step"},
                        { text: "You: Sing the Joyful Jingle", sender: "step" },
                        {text: "Step 3: Achieve It!", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: I am a bird trainer. How can I help you?", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "You: Can I feed the birds please?", sender: "student" },
                        { text: "Your friend: Yes, you can feed the birds. Thank you for asking. You are using good manners.", sender: "friend" },
                        { text: "You: Thanks! ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                    ],
                    [
                        {text: "Step 1: Think about what you want to say", sender: "step"},
                        { text: `You: Think about "Can you please tell me where I can buy a train ticket?"`, sender: "step" },
                        {text: "Step 2: Believe in yourself", sender: "step"},
                        { text: "You: Sing the Joyful Jingle", sender: "step" },
                        {text: "Step 3: Achieve It!", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: My name is (say your name) and I am a train conductor. How can I help you?", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "You: Can you please tell me where I can buy a train ticket?", sender: "student" },
                        { text: "Your friend: Yes, you can buy a ticket around the corner at the window, and thanks for using good manners.", sender: "friend" },
                        { text: "You: Thanks! ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                    ],
                    [
                        {text: "Step 1: Think about what you want to say", sender: "step"},
                        { text: `You: Think about "What do monkeys like to eat?"`, sender: "step" },
                        {text: "Step 2: Believe in yourself", sender: "step"},
                        { text: "You: Sing the Joyful Jingle", sender: "step" },
                        {text: "Step 3: Achieve It!", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: I am a monkey trainer. How can I help you?", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "You: What do monkeys like to eat?", sender: "student" },
                        { text: "Your friend: Monkeys like to eat lots of foods such as seeds and fruits, thank you for asking a great question.", sender: "friend" },
                        { text: "You: Thanks! ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                    ],
                    [
                        {text: "Step 1: Think about what you want to say", sender: "step"},
                        { text: `You: Think about "Can you help me find my teacher?"`, sender: "step" },
                        {text: "Step 2: Believe in yourself", sender: "step"},
                        { text: "You: Sing the Joyful Jingle", sender: "step" },
                        {text: "Step 3: Achieve It!", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: I work with reptiles. How may I help you?", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "You: Can you help me find my teacher?", sender: "student" },
                        { text: "Your friend: Yes, of course. I will call for help and have your teacher meet us here.", sender: "friend" },
                        { text: "You: Thanks! ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                    ],
                    [
                        {text: "Step 1: Think about what you want to say", sender: "step"},
                        { text: `You: Think about "Can I get a napkin, please?"`, sender: "step" },
                        {text: "Step 2: Believe in yourself", sender: "step"},
                        { text: "You: Sing the Joyful Jingle", sender: "step" },
                        {text: "Step 3: Achieve It!", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: I work at the Snack Shack. How can I help you?", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "You: Can I get a napkin please?", sender: "student" },
                        { text: "Your friend: Of course, the napkins are right by the drinks.", sender: "friend" },
                        { text: "You: Thanks! ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                    ],
                ];
                

                order = [7, 5, 10, 11];

                exampleVideos = [
                    'appfiles/freeplay/favorite/demo_color.mp4',
                    'appfiles/freeplay/favorite/demo_animal.mp4',
                    'appfiles/freeplay/favorite/demo_food.mp4',
                    'appfiles/freeplay/favorite/demo_game.mp4',
                    'appfiles/freeplay/favorite/demo_outside.mp4',
                ];
                codes = [
                    'BIRD',
                    'TRAIN',
                    'MONKEY',
                    'CARE',
                    'SNACK',
                ];
                celebrateAudios = ['appfiles/self_advocacy/self_advocacy_celebrate_record_think.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_believe.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_achieve.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_speak_up.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_stand_up.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I can do it all, because I think about what I want to say or do!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I believe in myself!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I achieve great things!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I can speak up for myself!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I can stand up for myself!"`]
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                setCompletePrompt(`FREEPLAY_SET_LEVEL2_ADVOCACY_${codes[topicPlay]}`)
                setTopicName(`ADVOCACY_${codes[topicPlay]}`)
                break;
            case 7:
                name = 'Using Good Manners'
                instructions = [
                    [
                        'Choose your greeting',
                        'Choose your greeting',
                        'What is your favorite snow cone flavor? My Favorite flavor is',
                        'Choose your response',
                        'Choose your closing',
                        'Choose your closing',
                    ],
                    [
                        'Choose your greeting',
                        'Choose your greeting',
                        'What is your favorite thing to do at the beach? I like to',
                        'Choose your response',
                        'Choose your closing',
                        'Choose your closing',
                    ],
                    [
                        'Choose your greeting',
                        'Choose your greeting',
                        'Would you like the ferris wheel to go fast or slow? I would like the ferris wheel to go',
                        'Choose your response',
                        'Choose your closing',
                        'Choose your closing',
                    ],
                    [
                        'Choose your greeting',
                        'Choose your greeting',
                        'What is your favorite game at the arcade? My favorite game is',
                        'Choose your response',
                        'Choose your closing',
                        'Choose your closing',
                    ],
                    [
                        'Choose your greeting',
                        'Choose your greeting',
                        'What fast food would you order? I would order',
                        'Choose your response',
                        'Choose your closing',
                        'Choose your closing',
                    ],
                    [
                        'Choose your greeting',
                        'Choose your greeting',
                        'Give the hairdresser a compliment',
                        'Choose your response',
                        'Choose your closing',
                        'Choose your closing',
                    ],
                    [
                        'Choose your greeting',
                        'Choose your greeting',
                        'What do you need help finding at the clothing store? Can you please help me find the',
                        'Choose your response',
                        'Choose your closing',
                        'Choose your closing',
                    ],
                    [
                        'Choose your greeting',
                        'Choose your greeting',
                        'What is your favorite cupcake flavor? My favorite flavor is',
                        'Choose your response',
                        'Choose your closing',
                        'Choose your closing',
                    ],
                    [
                        'Choose your greeting',
                        'Choose your greeting',
                        'How are you today?',
                        'Choose your response',
                        'What are you here to buy? I am here to buy a',
                        'Choose your response',
                        'Choose your closing',
                        'Choose your closing',
                    ],
                    [
                        'Choose your greeting',
                        'Choose your greeting',
                        'How are you today?',
                        'Choose your response',
                        'Choose your closing',
                        'Choose your closing',
                    ]
                ];
                texts = [
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'strawberry.',
                            'lemon.',
                            'blue raspberry.',
                            'tigers blood.',
                            'orange.',
                            '[say your own choice].',
                        ],
                        [
                            'Awesome!',
                            'That is great!',
                            'Great choice!',
                            'I love that answer!',
                            'Yummy!',
                            '[say your own choice].',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'swim.',
                            'build sand castles.',
                            'play in the waves.',
                            'fish.',
                            'watch the birds.',
                            '[say your own choice].',
                        ],
                        [
                            'Awesome!',
                            'That is great!',
                            'Great choice!',
                            'I love that answer!',
                            'Fun!',
                            '[say your own choice].',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'fast.',
                            'slow.',
                            'both fast and slow.',
                            'extra fast.',
                            'super slow.',
                            '[say your own choice].',
                        ],
                        [
                            'Awesome!',
                            'That is great!',
                            'Great choice!',
                            'I love that answer!',
                            'Fun!',
                            '[say your own choice].',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'skee-ball.',
                            'Donkey Kong.',
                            'Pac-Man.',
                            'air hockey.',
                            'basketball.',
                            '[say your own choice].',
                        ],
                        [
                            'Awesome!',
                            'That is great!',
                            'Great choice!',
                            'I love that answer!',
                            'Fun!',
                            '[say your own choice].',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'a hamburger.',
                            'chicken nuggets.',
                            'fries.',
                            'a chicken sandwich.',
                            'tacos.',
                            '[say your own choice].',
                        ],
                        [
                            'Awesome!',
                            'That is great!',
                            'Great choice!',
                            'I love that answer!',
                            'Yummy!',
                            '[say your own choice].',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'You do a great job!',
                            'I love your haircuts!',
                            'You give the best haircuts!',
                            'Thank you for always doing a great job!',
                            'I would love to cut hair just like you!',
                            '[say your own choice].',
                        ],
                        [
                            'Awww, that makes me feel warm inside!',
                            'Thank you so much!',
                            'I love getting compliments, thank you!',
                            'That makes me feel so good!',
                            'You just made my day!',
                            '[say your own choice].',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'socks?',
                            'sports clothes?',
                            'jewelry?',
                            'shoes?',
                            'hats?',
                            '[say your own choice]?',
                        ],
                        [
                            'It’s on the first aisle on your right.',
                            'One row over.',
                            'On the second shelf.',
                            'Aisle 10.',
                            'You will find it on the back wall.',
                            '[say your own choice].',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'strawberry.',
                            'vanilla.',
                            'chocolate.',
                            'birthday cake.',
                            'lemon.',
                            '[say your own choice].',
                        ],
                        [
                            'Awesome!',
                            'Nice!',
                            'I love that too!',
                            'Great choice!',
                            'Yummy!',
                            '[say your own choice].',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'I am doing fantastic!',
                            'I am wonderful!',
                            'I am good, thank you!',
                            'Great, thank you for asking!',
                            'I am good!',
                        ],
                        [
                            'Awesome!',
                            'Nice!',
                            'Wonderful!',
                            'Great!',
                            'That is great!',
                            '[say your own choice].',
                        ],
                        [
                            'candy bar please.',
                            'pack of gum please.',
                            'loaf of bread please.',
                            'juice please.',
                            'candy please.',
                            '[say your own choice].',
                        ],
                        [
                            'That will be .65 cents.',
                            'That will be $1.',
                            'That will be $2.',
                            'That will be $3.',
                            'That will be $4.',
                            'That will be $5.',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ]
                    ],
                    [
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'Hello!',
                            'Hi!',
                            'Good morning!',
                            'Good afternoon!',
                            'It is good to see you!',
                            'Nice to see you!',
                        ],
                        [
                            'I am doing fantastic!',
                            'I am wonderful!',
                            'I am good, thank you!',
                            'Great, thank you for asking!',
                            'I am good!',
                            '[say your own choice].',
                        ],
                        [
                            'Awesome!',
                            'Nice!',
                            'Wonderful!',
                            'Great!',
                            'That is great!',
                            '[say your own choice].',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ],
                        [
                            'Goodbye!',
                            'Bye!',
                            'See you later!',
                            'See you soon!',
                            'Have a great day!',
                            'It was great talking to you!',
                        ]
                    ]
                ];
                conversations = [
                    [
                        {text: "Step 1: How I Act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arm's length.", sender: "step"},
                        {text: "Step 2: What I Say: Use kind words.", sender: "step"},
                        {text: "Step 3: How I Say It:  Talk to the community workers in a calm voice.", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: My name is (say your name). My job is to make snow cones.", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: What is your favorite snow cone flavor?", sender: "friend" },
                        { text: "You: My favorite flavor is ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" }
                    ],
                    [
                        {text: "Step 1: How I Act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arm's length.", sender: "step"},
                        {text: "Step 2: What I Say: Use kind words.", sender: "step"},
                        {text: "Step 3: How I Say It:  Talk to the community workers in a calm voice.", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: My name is (say your name) and I am a lifeguard. I am here to help keep people safe.", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: What is your favorite thing to do at the beach?", sender: "friend" },
                        { text: "You: I like to ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                    ],
                    [
                        {text: "Step 1: How I Act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arm's length.", sender: "step"},
                        {text: "Step 2: What I Say: Use kind words.", sender: "step"},
                        {text: "Step 3: How I Say It:  Talk to the community workers in a calm voice.", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: I take tickets from people to ride the ferris wheel.", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: Would you like the ferris wheel to go fast or slow?", sender: "friend" },
                        { text: "You: I would like the ferris wheel to go ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" }
                    ],
                    [
                        {text: "Step 1: How I Act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arm's length.", sender: "step"},
                        {text: "Step 2: What I Say: Use kind words.", sender: "step"},
                        {text: "Step 3: How I Say It:  Talk to the community workers in a calm voice.", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: My name is (say your name) and I work at the arcade.", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: Nice to meet you! I love to see the kids play and win the games. What is your favorite game?", sender: "friend" },
                        { text: "You: My favorite game is ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" }
                    ],
                    [
                        {text: "Step 1: How I Act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arm's length.", sender: "step"},
                        {text: "Step 2: What I Say: Use kind words.", sender: "step"},
                        {text: "Step 3: How I Say It:  Talk to the community workers in a calm voice.", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: Hi! My name is (say your name) and I am a fast food worker.", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: Nice to meet you. If you were to order fast food, would you order a hamburger, chicken nuggets or something else?", sender: "friend" },
                        { text: "You: I would order ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" }
                    ],
                    [
                        {text: "Step 1: How I Act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arm's length.", sender: "step"},
                        {text: "Step 2: What I Say: Use kind words.", sender: "step"},
                        {text: "Step 3: How I Say It:  Talk to the community workers in a calm voice.", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: Hi! My name is (say your name) and I am a stylist.", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: I love to cut hair to make people look great.", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" }
                    ],
                    [
                        {text: "Step 1: How I Act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arm's length.", sender: "step"},
                        {text: "Step 2: What I Say: Use kind words.", sender: "step"},
                        {text: "Step 3: How I Say It:  Talk to the community workers in a calm voice.", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: I work at a clothing store.", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: If you need to find clothing, it is my job to help you find it.", sender: "friend" },
                        { text: "You: Can you please help me find the ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" }
                    ],
                    [
                        {text: "Step 1: How I Act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arm's length.", sender: "step"},
                        {text: "Step 2: What I Say: Use kind words.", sender: "step"},
                        {text: "Step 3: How I Say It:  Talk to the community workers in a calm voice.", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: My name is (say your name) and I work at the bakery.", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: I love to bake cupcakes. What is your favorite flavor?", sender: "friend" },
                        { text: "You: My favorite flavor is ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" }
                    ],
                    [
                        {text: "Step 1: How I Act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arm's length.", sender: "step"},
                        {text: "Step 2: What I Say: Use kind words.", sender: "step"},
                        {text: "Step 3: How I Say It:  Talk to the community workers in a calm voice.", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: My name is (say your name) and I work at a grocery store. How are you today?", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: Wonderful! What are you here to buy?", sender: "friend" },
                        { text: "You: I am here to buy a ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" }
                    ],
                    [
                        {text: "Step 1: How I Act: Remember to look at their eyes, listen, smile, keep your body tall and stand at arm's length.", sender: "step"},
                        {text: "Step 2: What I Say: Use kind words.", sender: "step"},
                        {text: "Step 3: How I Say It:  Talk to the community workers in a calm voice.", sender: "step"},
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: I work at the movie theater. How are you today?", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" },
                        { text: "Your friend: It is my job to look at movie tickets. Can I see your movie ticket?", sender: "friend" },
                        { text: "You: Here you go.", sender: "student" },
                        { text: "Your friend: Thank you. I love that movie. It’s the first movie theater on the right.", sender: "friend" },
                        { text: "You: ", sender: "student" },
                        { text: "Your friend: ", sender: "friend" }
                    ]
                ];
                
                order = [5, 3, 7, 8, 9, 10];
                order9 = [5, 3, 6, 7, 9, 10, 11, 12];
                order10 = [5, 3, 6, 7, 11, 12]

                exampleVideos = [
                    'appfiles/freeplay/favorite/demo_color.mp4',
                    'appfiles/freeplay/favorite/demo_animal.mp4',
                    'appfiles/freeplay/favorite/demo_food.mp4',
                    'appfiles/freeplay/favorite/demo_game.mp4',
                    'appfiles/freeplay/favorite/demo_outside.mp4',
                ];
                codes = [
                    'CONE',
                    'GUARD',
                    'WHEEL',
                    'ARCADE',
                    'FOOD',
                    'SALON',
                    'CLOTHING',
                    'BAKERY',
                    'GROCERY',
                    'THEATER'
                ];
                celebrateAudios = ['appfiles/manners/manners_celebrate_please.mp3',
                    'appfiles/manners/manners_celebrate_thank.mp3',
                    'appfiles/manners/manners_celebrate_calm.mp3',
                    'appfiles/manners/manners_celebrate_smile.mp3',
                    'appfiles/manners/manners_celebrate_body_tall.mp3',
                    'appfiles/caring/caring_celebrate_record_take_care_myself.mp3',
                    'appfiles/caring/caring_celebrate_record_take_care_others.mp3',
                    'appfiles/caring/caring_celebrate_record_take_care_world.mp3',
                    'appfiles/caring/caring_celebrate_record_see_fix.mp3',
                    'appfiles/caring/caring_celebrate_record_hard_things.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I am awesome because I say please!"`,
                    `Record yourself in an excited voice and say, "I am awesome because I say thank you!"`,
                    `Record yourself in an excited voice and say, "I am awesome because I talk in a calm voice."`,
                    `Record yourself in an excited voice and say, "I am awesome because I smile!"`,
                    `Record yourself in an excited voice and say, "I am awesome because I keep my body tall!"`,
                    `Record yourself in an excited voice and say, "I believe in me because I take care of myself!"`,
                    `Record yourself in an excited voice and say, "I believe in me because I take care of others!"`,
                    `Record yourself in an excited voice and say, "I believe in me, because I take care of the world!"`,
                    `Record yourself in an excited voice and say, "I believe in me, because I can see it, fix it and make it even better!"`,
                    `Record yourself in an excited voice and say, "I believe in me, because I can do hard things!"`]
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                setCompletePrompt(`FREEPLAY_SET_LEVEL2_COMMUNITY_${codes[topicPlay]}`)
                setTopicName(`COMMUNITY_${codes[topicPlay]}`)
                break;
            default:
                break;
        }
        setName(name)
        setPractice(
            <Build
                title={name}
                selectedStudentCharacter={selectedStudentCharacter}
                selectedFriendCharacter={selectedFriendCharacter}
                instructions={instructions[topicPlay]}
                texts={texts[topicPlay]}
                conversation={conversations[topicPlay]}
                order={order}
                order9={order9}
                order10={order10}
                topic={codes[topicPlay]}
                topicNum={topicPlay}
                setSelectedConversation={setSelectedConversation}
                finish={()=>{setDisplayStep3(false); setDisplayCoin(true);}}
            />
        );
        setDisplaySurpriseVideoIcon(false);
        setDisplayStep3(true)
        // setDisplayShare(true)
        // setDisplayGame(true)
    }

    const onStop = (bought, data) => {
        const position = { x: data.x / clientWidth, y: data.y / clientHeight };
        freeplay.level2Decorate.items = freeplay.level2Decorate.items.map(item => 
            item === bought? {...item, position} : item
        );
        setBoughts(freeplay.level2Decorate.items)
    };

    const goBack = () => {
        if(displayStep1){
            setDisplayStep0(true);  
            setDisplayStep1(false)
        }
        else if(displayStep2){
            setDisplayStep1(true);  
            setDisplayStep2(false);
            setDisplaySurpriseVideoIcon(false);
        }
        else if(displayStep3){
            setDisplayStep2(true); 
            setDisplayStep3(false)
        }
        else if(displayStep3){
            setDisplayStep2(true); 
            setDisplayStep3(false)
        }
        else if(displayStep4){
            setDisplayStep3(true); 
            setDisplayStep4(false)
        }
        else if(displayValuation){
            setDisplayStep4(true); 
            setDisplayValuation(false)
        }
        else{
            navigate("/freeplay_2")
        }
    };

    const checkCompletion = async () => {
        dispatch({ type: `FREEPLAY_SET_LEVEL2_SHAREDCOIN`, payload: 0 });
        switch (conversationNum) {
            case 0:
                if (Object.values(freeplay.level2.favorite).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level2_favorite_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level2/masks/fish_mask.png')} animalName={'fish'} level={'level2'} topic={'favorite'} width={96} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 1:
                if (Object.values(freeplay.level2.feeling).filter(value => value.unlocked === 1).length === 6) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level2_feeling_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level2/masks/octopus_mask.png')} animalName={'octopus'} level={'level2'} topic={'feeling'} width={130} height={200} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 2:
                if (Object.values(freeplay.level2.listening).filter(value => value.unlocked === 1).length === 6) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level2_listening_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level2/masks/frog_mask.png')} animalName={'frog'} level={'level2'} topic={'listening'} width={95} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 3:
                if (Object.values(freeplay.level2.friends).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level2_friends_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level2/masks/gnome_mask.png')} animalName={'gnome'} level={'level2'} topic={'friends'} width={80} height={140} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 4:
                if (Object.values(freeplay.level2.solution).filter(value => value.unlocked === 1).length === 3) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level2_solution_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level2/masks/owl_mask.png')} animalName={'owl'} level={'level2'} topic={'solution'} width={110} height={190} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 5:
                if (Object.values(freeplay.level2.conflict).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level2_conflict_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level2/masks/dinosaur_mask.png')} animalName={'dinosaur'} level={'level2'} topic={'conflict'} width={100} height={200} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 6:
                if (Object.values(freeplay.level2.advocacy).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level2_advocacy_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level2/masks/sasquatch_mask.png')} animalName={'sasquatch'} level={'level2'} topic={'advocacy'} width={95} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            case 7:
                if (Object.values(freeplay.level2.community).filter(value => value.unlocked === 1).length === 10) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level2_community_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/level2/masks/alien_mask.png')} animalName={'alien'} level={'level2'} topic={'community'} width={95} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayShare(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay_2");
                    }
                }
                else{
                    navigate("/freeplay_2");
                }
                break;
            default:
                break;
        }
    };
    

    const retakePhoto = (item) => {
        let height = 160;
        let width = 95;
        switch(item.animal){
            case "fish":
                width = 96;  
                break;
            case "octopus":
                height = 200;
                width = 130;  
                break;
            case "gnome":
                height = 140;
                width = 80; 
                break;
            case "owl":
                height = 190;
                width = 110; 
                break;
            case "dinosaur":
                height = 200;
                width = 100; 
                break;
            default:
                break;
        }
        setAnimal(<Animal animal={generateImageUrl(`images/newDesign/FreePlay/level2/masks/${item.animal}_mask.png`)} animalName={item.animal} level={'level2'} topic={item.name} width={width} height={height} setDisplayAnimal={setDisplayAnimal}  getAnimals={getAnimals} finish={()=>{setDisplayStoreCharacter(true); setDisplayAnimal(false);}}/>)
        setDisplayStore(false);
        setDisplayStoreCharacter(false);
        setDisplayAnimal(true);
    }

    const getSurprise = async () => {
        let usePhoto = []
        switch(conversationNum){
            case 0:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FAVORITE_COLOR.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module16/Unit4_Mod1_SpecialReward_1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FAVORITE_ANIMAL.mp4`,
                    },
                ];
                break;
            case 1:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FEELING_CONFIDENT.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module16/Unit4_Mod1_SpecialReward_2.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FEELING_HAPPY.mp4`,
                    },
                ];
                break;
            case 2:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_LISTENING_HAPPY.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module17/Unit4_Mod2_Special Dance 1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_LISTENING_CALM.mp4`,
                    },
                ];
                break;
            case 3:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FRIENDS_SUBJECT.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module17/Unit4_Mod2_Special Dance 2.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FRIENDS_OUTSIDE.mp4`,
                    },
                ];
                break;
            case 4:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_SOLUTION_NERVOUS.mp4`,
                    },
                    {
                        video: `influencers/${influencers[2]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module18/Unit4_Mod3_SpecialReward_Dance 1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_SOLUTION_SAD.mp4`,
                    },
                ];
                break;
            case 5:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_CONFLICT_SHOP.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module18/Unit4_Mod3_SpecialRewards_Dance 2.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_CONFLICT_PHOTO.mp4`,
                    },
                ];
                break;
            case 6:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_ADVOCACY_TRAIN.mp4`,
                    },
                    {
                        video: `influencers/${influencers[3]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module19/Unit4_Mod4_SpecialReward_Dance 1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_ADVOCACY_CARE.mp4`,
                    },
                ];
                break;
            case 7:
            usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_COMMUNITY_FOOD.mp4`,
                    },
                    {
                        video: `influencers/${influencers[4]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `media/Module20/Unit4_Mod5_SpecialReward 1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_COMMUNITY_THEATER.mp4`,
                    },
                ];
                break;
            default:
                break;
        }

        for (let i = 0; i < usePhoto.length; i++) {
            if(usePhoto[i].video.includes("media")){
                usePhoto[i].video = generateImageUrl(usePhoto[i].video)
            }
            else{
                await GetUserVideo(usePhoto[i].video, login).then((data) => {
                    usePhoto[i].video = data;
                });
            }
        }
        
        return usePhoto;
    };
    
    const playSurpriseVideo = async (intro = true) => {
        let music = ""
        switch(conversationNum){
            case 0:
                music = "appfiles/manners/manners_instrumental.m4a"
                break;
            case 1:
                music = "appfiles/manners/manners_instrumental.m4a"
                break;
            case 2:
                music = "appfiles/friends_bullying/friends_bullying_instrumental.m4a"
                break; 
            case 3:
                music = "appfiles/friends_bullying/friends_bullying_instrumental.m4a"
                break; 
            case 4:
                music = "appfiles/expressions/faces_student_instrumental.m4a"
                break; 
            case 5:
                music = "appfiles/expressions/faces_student_instrumental.m4a"
                break; 
            case 6:
                music = "appfiles/posture/posture_student_instrumental.m4a"
                break; 
            case 7:
                music = "appfiles/distance/distance_student_instrumental.m4a"
                break; 
            default:
                break;
        }
        await getSurprise().then((photo) => {
            setSurpriseVideo(
            <Surprise
                background={backgrounds[bgIdx]}
                music={getVideo(music, login)}
                // music={generateImageUrl('media/Freeplay/surprise_intrumental.mp3')}
                introVideo={intro ? 'd6c6b74e964a62fe8a9940bd860c/480.m3u8' : ""}
                slides={photo}
                level2={true}
                setDisplaySurprise={setDisplaySurpriseVideo}
            />
            );
        });
        setDisplaySurpriseVideo(true);
    };

    return (
        <>
        {displaySurpriseVideo && surpriseVideo}
        {!displaySurpriseVideo &&
        <div className='level2Body' style={{ backgroundImage: `url(${backgrounds[bgIdx]})`,  overflowY: "scroll"}}>
            {displayDecorate && !displayStore &&  !displayStoreCharacter &&<div className='decorate' style={{zIndex : !change ? 1 : 0}}>
                    {/* <h2><a onClick={() => {navigate("/freeplay_2")}}>&#60; BACK</a></h2> */}
                    {/* <img className='bin' id='bin' src={Bin}/> */}
                    <img alt='store button' className='store' src={Store} onClick={() => {setDisplayStore(true); setDisplayAnimal(false)}}/>
                    <footer>
                        <h2><a onClick={displayAnimal ? () => {setDisplayAnimal(false); setDisplayStoreCharacter(true)} : () => {navigate("/freeplay_2")}}>&#60; BACK</a></h2>
                    </footer> 
            </div>}
            {(displayStep0 || displayStep1 || displayStep2 || displayCoin || displayCelebrate || displayCoinAfterCelebrate || displayCoinAfterConversation || displayCoinAfterValuation || displayShare) && <header>
                <div className='actions'>
                    {/* {(displayStep1 || displayStep2) && <h2><a onClick={goBack}>&#60; BACK</a></h2>} */}
                    {displaySurpriseVideoIcon && (
                        <img className='surprise' src={giftBtn} alt='Surprise Video' onClick={()=>{playSurpriseVideo(false)}} />
                    )}                
                </div>
                <div className='coins'>
                    <img alt='coin icon' src={coin}/>
                    {freeplay.level2Coin < 10 && <div className='coin1'>{freeplay.level2Coin}</div>}
                    {freeplay.level2Coin >= 10 && freeplay.level2Coin < 100 && <div className='coin10'>{freeplay.level2Coin}</div>}
                    {freeplay.level2Coin >= 100 && <div className='coin100'>{freeplay.level2Coin}</div>}
                </div>
            </header>}
            {(displayStep3 || displayStep4) && <header>
                <img
                    className='back-btn-ftb'
                    alt='back button'
                    src={Exit}
                    onClick={() => {
                        setDisplayStep3(false)
                        setDisplayStep4(false)
                        setDisplayStep1(true)
                    }}
                ></img>
            </header>}
            <footer>
                {(displayStep0 || displayStep1 || displayStep2 || displayStep3 || displayStep4 || displayValuation) && <h2><a onClick={goBack}>&#60; BACK</a></h2>}
                {displayShare && <h2 style={{ position: "fixed", right: "40px", bottom: "20px",}}><a onClick={checkCompletion}>NEXT &#62;</a></h2>}
            </footer> 
            {displayStore && storeReady && <StorePage getAnimals={getAnimals} coin={freeplay.level2Coin} level={"LEVEL2"} decorate={freeplay.level2Decorate} bgs={backgrounds} setBgIdx={setBgIdx} buys={buys} boughts={boughts} setBoughts={setBoughts} close={setDisplayStore} animals={animals} setUpdate={setUpdate} update={update} setChange={setChange} retakePhoto={retakePhoto}/>}
            {displayStoreCharacter && storeReady && <StorePage getAnimals={getAnimals} coin={freeplay.level2Coin} level={"LEVEL2"} decorate={freeplay.level1Decorate} bgs={backgrounds} setBgIdx={setBgIdx} buys={buys} boughts={boughts} setBoughts={setBoughts} close={setDisplayStoreCharacter} animals={animals} setUpdate={setUpdate} update={update} setChange={setChange} retakePhoto={retakePhoto} character={true}/>}
            {displayStep0 && <Intro finish={()=>{setDisplayStep0(false); setDisplayStep1(true)}} setSelectedStudentCharacter={setSelectedStudentCharacter} setSelectedFriendCharacter={setSelectedFriendCharacter}/>}
            {displayStep1 && <div className='conversation'>
                <h2 className='header'>
                    Choose Your Conversation
                </h2>
                <h3 className='text'>
                    Click the conversation you want to practice
                </h3>
                <Container>
                    <Row xs={2} md={3} lg={4}>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(0, 'Favorite Things')}}>
                                <div className='text'>Favorite Things</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level2.favorite).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.favorite).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level2.favorite).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level2.favorite).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(1, 'Talk about Feelings')}}>
                                <div className='text'>Talk about Feelings</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level2.feeling).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.feeling).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level2.feeling).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level2.feeling).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(2, 'Active Listening')}}>
                                <div className='text'>Active Listening</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level2.listening).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.listening).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level2.listening).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level2.listening).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(3, 'Making Friends')}}>
                                <div className='text'>Making Friends</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level2.friends).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.friends).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level2.friends).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level2.friends).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(4, 'Solutions')}}>
                                <div className='text'>Solutions</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level2.solution).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.solution).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level2.solution).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level2.solution).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(5, 'Resolve Conflict')}}>
                                <div className='text'>Resolve Conflict</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level2.conflict).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.conflict).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level2.conflict).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level2.conflict).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(6, 'Self-Advocacy')}}>
                                <div className='text'>Self-Advocacy</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level2.advocacy).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.advocacy).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level2.advocacy).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level2.advocacy).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(7, 'Community Locations: Manners & Caring')}}>
                                <div className='text'>Community Locations</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level2.community).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level2.community).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level2.community).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level2.community).length} Completed</div>}
                            </div>
                        </Col>
    
                    </Row>
                </Container>
            </div>}
            {displayStep2 && <div className='topic'>
                <h2 className='header'>
                    {conversationName}
                </h2>
                <h3 className='text'>
                    Click the topic you want to practice
                </h3>
                <div className={`conversation_${conversationNum}`}>
                    <Container>
                        <Row xs={2} md={3} lg={4}>
                            {topics.map((topic, index) => (
                                <Col key={index}> 
                                    <div className='option' onClick={() => {settopic(index)}}>
                                        <div className='text'>{topic.text}</div>
                                        <div className='icon'>
                                            <img alt='topic icon' src={topic.img} />
                                        </div>
                                        {topic.completed === 1 && <div className='optionProgress'>Completed</div>}                                 
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </div>
            </div>}
            {displayStep3 && practice}
            {displayCoin && <Coin level={'LEVEL2'} coin={freeplay.level2Coin} close={() => {setDisplayCoin(false); setDisplayStep4(true)}}/>}
            {displayStep4 && <Conversation finish={() => {dispatch({type: completePrompt, payload: 1}); setDisplayStep4(false); setDisplayCoinAfterConversation(true)}} close={() => {setDisplayStep4(false); setDisplayStep2(true)}} selectedStudentCharacter={selectedStudentCharacter} selectedFriendCharacter={selectedFriendCharacter} selectedConversation={selectedConversation} topicName={name}/>}
            {displayCoinAfterConversation && <Coin level={'LEVEL2'} coin={freeplay.level2Coin} close={() => {setDisplayCoinAfterConversation(false); setDisplayValuation(true)}}/>}
            {displayValuation && <Valuation finish={() => {setDisplayValuation(false); setDisplayCoinAfterValuation(true)}} close={() => {setDisplayStep4(false); setDisplayStep2(true)}} name={conversationNames[conversationNum]}  day={getNestedLength(freeplay.level2)}/>}
            {displayCoinAfterValuation && <Coin level={'LEVEL2'} coin={freeplay.level2Coin} close={() => {setDisplayCoinAfterValuation(false); setDisplayCelebrate(true)}}/>}
            {displayCelebrate && <Celebrate
              voice1={celebrateVoice}
              voice2={getVideo('appfiles/eye_contact/crab_awesome_job.mp3', login)}
              text={celebrateText}
              name={`level2_celebration_${topicName}.mp4`}
              animation={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
              close={() => {updateProgress(); setDisplayCelebrate(false); setDisplayCoinAfterCelebrate(true)}}
            />}
            {displayCoinAfterCelebrate && <Coin coin={freeplay.level2Coin} level={'LEVEL2'} close={() => {setDisplayCoinAfterCelebrate(false); setDisplayGame(true)}}/>}
            {displayGame && <Game checkCompletion={()=>{setDisplayShare(true); setDisplayGame(false)}} coin={freeplay.level2Coin} level={'LEVEL2'}/>}
            {displayShare && <Share setDisplayShare={setDisplayShare} checkCompletion={checkCompletion} sharedCoin={freeplay.level2SharedCoin}/>}
            {displayAnimal && animal}     
            {prize && (
                <img
                    className='present'
                    style={{
                    width: '84px',
                    height: '100px',
                    marginLeft: '-42px',
                    zIndex: 10,
                    }}
                    id='bounceIcons'
                    src={giftBtn}
                    alt='gift'
                    onClick={() => {
                        playSurpriseVideo();
                        setPrize(false);
                        sleep(2000).then(() => {setDisplayStep1(true);});
                    }}
                />
            )}
            {(prize || displayShare) && (
                <audio autoPlay>
                    <source src={presentSound}></source>
                </audio>
            )}             
            {!displayDecorate && <div className='transparentArea'></div>}
            <div className='decorateArea' style={{zIndex : change ? 1 : 0}}>
                {change && <div className="text">Drag and drop your item</div>}
                <img
                    className='confirmDecorate'
                    style={{opacity : change ? 1 : 0, pointerEvents : change ? "auto" : "none"}}
                    src={greenCheck}
                    alt='confirm button'
                    onClick={()=>{greenCheckSound.play(); setChange(false); setUpdate(!update)}}
                />
                {boughts.map((bought, index) => (
                    <Draggable
                        key={index}
                        disabled={!displayDecorate}
                        bounds='parent'
                        position={{
                        x: bought.position.x * clientWidth,
                        y: bought.position.y * clientHeight,
                        }}
                        onStart={()=>{setChange(true);}}
                        onStop={(e, data) => {
                            onStop(bought, data);
                        }}
                    >
                    {bought.url.includes("https:") ?
                        <div className={`item ${bought.name}`}>
                            <img alt='reward' draggable="false" src={bought.url}/>
                        </div>
                        :
                        <div className={`item level2-${bought.name}`}>
                            <img alt='reward' draggable="false" src={generateImageUrl(bought.url)}/>
                        </div>
                    }
                  </Draggable>
                ))}
            </div>
        </div>}
        </>
    );
};
export default Level2;

